// Switch to reading runtime-injected env (window.__env) with build-time fallbacks
declare global {
  interface Window {
    __env?: {
      API_URL?: string;
      WEB_APP_URL?: string;
    };
  }
}

export const api = {
  API_URL: window.__env?.API_URL ?? (process.env.REACT_APP_API_URL as string) ?? '',
  WEB_APP_URL: window.__env?.WEB_APP_URL ?? (process.env.REACT_APP_WEB_URL as string) ?? '',
};

export default api
